import { Component, OnDestroy, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { finalize, Observable, Subscription } from 'rxjs';
import { CesionariosService } from '../../service/cesionarios.service';
import { CesionarioSummaryFilter, InvoiceCesionarioQueryParam } from '../interfaces/cesionario-viewmodel.interface';
import { ChangePaginationEvent, ChangeSortingEvent, PageResult } from 'src/app/common/interfaces/paged-result.interface';
import { CedidoInvoiceDTO, CesionarioReceivedInvoiceDTO, CompanyCesionarioSummaryDTO } from '../interfaces/company-cesionario.interface';
import { DateFiltersFilesClients } from '../../files-clients/interface/filters-files-clients.interface';
import { DebtsCompaniesAll } from '../../files-clients/interface/company-client.interface';
import { ServiceInfoClientService } from '../../files-clients/service/service-info-client.service';
import { FogapeInfoClient } from '../../files-clients/interface/fogape-client.interface';
import { ScoringIngeService } from '../../files-clients/service/scoring-inge.service';
import { MatDialog, MatDialogConfig } from '@angular/material/dialog';
import { CmfFormComponent } from '../../files-clients/components/forms/cmf-form/cmf-form.component';
import { DicomFormularioComponent } from '../../files-clients/modals/dicom-formulario/dicom-formulario.component';
import { TgrFormComponent } from '../../files-clients/components/forms/tgr-form/tgr-form.component';
import { ModalLoadingFileClientsComponent } from '../../modals/modal-loading-file-clients/modal-loading-file-clients.component';

@Component({
  selector: 'app-formula-company-detail',
  templateUrl: './formula-company-detail.component.html',
  styleUrls: ['./formula-company-detail.component.scss']
})
export class FormulaCompanyDetailComponent implements OnInit, OnDestroy{
  private routeSub: Subscription;
  public pagedReceivedInvoices$: Observable<PageResult<CesionarioReceivedInvoiceDTO>>;
  public pagedCedidoInvoices$: Observable<PageResult<CedidoInvoiceDTO>>;

  public cesionarioCompanyId: number = 0;
  public receivedInvoiceQuery: InvoiceCesionarioQueryParam = {
    page: 1,
    size: 5,
    sortColumn: '',
    sortDirection: ''
  };
  public cedidoInvoiceQuery: InvoiceCesionarioQueryParam = {
    page: 1,
    size: 5,
    sortColumn: '',
    sortDirection: ''

  }

  public summaryCesionarioFilter: CesionarioSummaryFilter;
  public cesionarioSummaryDetail: CompanyCesionarioSummaryDTO | null = null;
  public loadingSummary: boolean = false;
  public cesionarioDebt: DebtsCompaniesAll;
  public fogapeCesionario?: FogapeInfoClient;
  public dicomDebt: number = 0;
  public hasDicomHistorial: boolean = false;

  constructor(private route: ActivatedRoute,
     private cesionarioService: CesionariosService, 
     private clientInfoService: ServiceInfoClientService,
     private equifaxService: ScoringIngeService,
     private dialog: MatDialog,
    ) {
    const currentDate = new Date();
    this.summaryCesionarioFilter = {
      start: new Date(currentDate.getFullYear(), currentDate.getMonth()-12, currentDate.getDate()),
      end: currentDate,
      search: ''
    }
  }
  ngOnInit(): void {
    this.routeSub = this.route.params.subscribe(params => {
      this.cesionarioCompanyId = params['id'];
      this.getCesionarioSummary(true);
      this.getReceivedInvoices();
      this.getCedidoInvoices();
      this.receiveDebtCompany();
      this.getDeudaDicom();
      this.getFogapeInfo();
    });
  }

  getReceivedInvoices() {
    this.pagedReceivedInvoices$ = this.cesionarioService.getReceivedInvoices(this.cesionarioCompanyId, this.receivedInvoiceQuery, this.summaryCesionarioFilter);
  }

  getCedidoInvoices(){
    this.pagedCedidoInvoices$ = this.cesionarioService.getCedidoInvoices(this.cesionarioCompanyId, this.cedidoInvoiceQuery, this.summaryCesionarioFilter);
  }

  receiveChangePaginationReceivedInvoices(event: ChangePaginationEvent) {
    this.receivedInvoiceQuery = {
      ...this.receivedInvoiceQuery,
      page: event.page,
      size: event.pageSize
    };
    this.getReceivedInvoices();
  }

  receiveChangeSortReceivedInvoices(event: ChangeSortingEvent) {
    this.receivedInvoiceQuery = {
      ...this.receivedInvoiceQuery,
      sortColumn: event.sortColumn,
      sortDirection: event.sortDirection
    };
    this.getReceivedInvoices();
  }

  receiveChangePaginationCedidoInvoices(event: ChangePaginationEvent) {
    this.cedidoInvoiceQuery = {
      ...this.cedidoInvoiceQuery,
      page: event.page,
      size: event.pageSize
    };
    this.getCedidoInvoices();
  }

  receiveChangeSortCedidoInvoices(event: ChangeSortingEvent) {
    this.cedidoInvoiceQuery = {
      ...this.cedidoInvoiceQuery,
      sortColumn: event.sortColumn,
      sortDirection: event.sortDirection
    };
    this.getCedidoInvoices();
  }

  getCesionarioSummary(showLoading: boolean = false) {
    if(showLoading) this.openLoadingModal();
    this.cesionarioService.getCesionarioSummary(this.cesionarioCompanyId, this.summaryCesionarioFilter)
    .pipe(
      finalize(() => {
        this.loadingSummary = true;
        if(showLoading) this.closeLoadingModal();
      })
    )
    .subscribe({
      next: (res) => {
        if(showLoading) this.closeLoadingModal();
        this.cesionarioSummaryDetail = res
      }
    })
  }

  receiveChangeFilters(filters: DateFiltersFilesClients) {
    this.summaryCesionarioFilter =  {
      ...this.summaryCesionarioFilter,
      start: new Date(filters.start),
      end: new Date(filters.end),
      search: filters.search || ''
    };
    this.getCesionarioSummary();
    this.getReceivedInvoices();
    this.getCedidoInvoices();
  }

  receiveDebtCompany() {
    this.clientInfoService.getDebtCompanies(this.cesionarioCompanyId)
    .subscribe({
      next: (res) => this.cesionarioDebt = res
    });
  }

  public refreshFogape(){
    this.getFogapeInfo();
  }

  loadingFogape: boolean = true;
  getFogapeInfo() {
    this.loadingFogape = true;
    this.clientInfoService.getFogapeInfo(this.cesionarioCompanyId)
    .pipe(
      finalize(() => this.loadingFogape = false)
    )
    .subscribe({
      next: (res) => this.fogapeCesionario = res
    })
  }

  getDeudaDicom() {
    this.equifaxService.getDeudaDicomBD(this.cesionarioCompanyId)
    .subscribe({
      next: (result) => {
        this.setDicomHistoric(result);
      }
    })
  }

  private setDicomHistoric(result: any) {
    this.dicomDebt = result?.deuda;
    if (result?.deuda == null) {
      this.hasDicomHistorial = false;
    } else if (Number(result?.deuda) <= 50000) {
      this.hasDicomHistorial = true;
    } else {
      this.hasDicomHistorial = true;
    }
  }

  public formCMF() {
    const dialogConfig = new MatDialogConfig();
    dialogConfig.disableClose = true;
    dialogConfig.panelClass = 'container_form_debts'
    dialogConfig.data = this.cesionarioCompanyId;
    const dialogRef = this.dialog.open(CmfFormComponent, dialogConfig);
    dialogRef.afterClosed()
      .subscribe((res: boolean) => {
        if (res) {
          this.receiveDebtCompany();
        } else {
          this.receiveDebtCompany();
        }
      });
  }

  public formDicom() {
    const dialogConfig = new MatDialogConfig();
    dialogConfig.disableClose = false;
    dialogConfig.width = '50vw';
    dialogConfig.height = '450px';
    dialogConfig.maxWidth = '90vw';
    dialogConfig.maxHeight = '90vh';
    dialogConfig.data = this.cesionarioSummaryDetail.cesionarioRut;

    const dialogRef = this.dialog.open(DicomFormularioComponent, dialogConfig);
    dialogRef.afterClosed().subscribe((res: boolean) => {
      this.receiveDebtCompany();
      if (res) {
        this.getDeudaDicom();
      } else {
        this.getDeudaDicom();
      }
    });
  }
  public formTGR() {
    const dialogConfig = new MatDialogConfig();
    dialogConfig.disableClose = true;
    dialogConfig.panelClass = 'container_form_debts'
    dialogConfig.data = this.cesionarioCompanyId;

    const dialogRef = this.dialog.open(TgrFormComponent, dialogConfig);
    dialogRef.afterClosed().subscribe((res: boolean) => {
      if (res) {
        this.receiveDebtCompany()
      } else {
        this.receiveDebtCompany()
      }
    });
  }

  private openLoadingModal() {
    const dialogConfig = new MatDialogConfig();
    dialogConfig.disableClose = true;
    dialogConfig.width = 'auto';
    dialogConfig.height = 'auto';
    dialogConfig.maxWidth = '90vw';
    dialogConfig.maxHeight = '90vh';
    dialogConfig.autoFocus = true;
    dialogConfig.panelClass = 'transparent-dialog';
    dialogConfig.backdropClass = 'transparent-backdrop';
    this.dialog.open(ModalLoadingFileClientsComponent, dialogConfig);
  }

  private closeLoadingModal() {
    this.dialog.closeAll();
  }

  ngOnDestroy(): void {
    this.routeSub.unsubscribe();
  }
}
